import React from 'react';
import { FormGroup, Button,Col,Row } from 'react-bootstrap';
import FloatingLabel from 'floating-label-react';
import { inputStyle } from '../helper/input-style';
import WSManager from "../WSHelper/WSManager";
import * as WSC from "../WSHelper/WSConstants";
import { MyContext } from '../InitialSetup/MyProvider';
import { Helmet } from "react-helmet";
import MetaData from "../helper/MetaData";
import ContestDetailModal from '../Modals/ContestDetail';
import ls from 'local-storage';
import ConfirmationPopup from '../Modals/ConfirmationPopup';
import Thankyou from '../Modals/Thankyou';
import * as AppLabels from "../helper/AppLabels";
import CustomHeader from '../components/CustomHeader';
import {Utilities} from '../Utilities/Utilities';
import { setValue, SELECTED_GAMET, GameType,EnableBuyCoin } from '../helper/Constants';
import { getUserTeams, joinContest, joinContestNetworkfantasy,checkContestEligibility,checkContestEligibilityMultiGame, joinContestWithMultiTeam } from '../WSHelper/WSCallings';

export default class HaveALeagueCodeClass extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            mLeagueCode: '',
            showContestDetail: false,
            clickOnce: false,
            showConfirmationPopUp: false,
            userTeamListSend: [],
            TotalTeam: [],
            LobyyData:[],
            showThankYouModal: false,
            isReverseF: false
        };


    }
    componentDidMount() {
        Utilities.handleAppBackManage('Join-contest')
    }
    ContestDetailShow = (data, activeTab) => {
        this.setState({
            showContestDetail: true,
            contestData: data,
            activeTab: activeTab,
        });
    }

    ContestDetailHide = () => {
        this.setState({
            showContestDetail: false,
        });
    }

    handleChange = (e) => {
        const value = e.target.value;
        this.setState({
            mLeagueCode: value,
        });
    }

    joinPrivateLeague() {
        this.setState({clickOnce: true})
        if (!WSManager.loggedIn()) {
            setTimeout(() => {
                this.props.history.push({ pathname: '/signup' })
                Utilities.showToast(AppLabels.Please_Login_Signup_First, 3000);
            }, 10);
        } else {
            if (this.state.mLeagueCode != "" && this.state.mLeagueCode.length > 3) {
                this.callHaveALeagueCodeApi();
            } else {
                Utilities.showToast(AppLabels.Please_enter_a_valid_league_code, 3000);
            }
        }
    }

    callHaveALeagueCodeApi() {
        let param = {
            'join_code': this.state.mLeagueCode
        }

        let apiMethod = SELECTED_GAMET == GameType.MultiGame ? checkContestEligibilityMultiGame : checkContestEligibility

        apiMethod(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {

                if(responseJson.data.total_user_joined == responseJson.data.size){
                    Utilities.showToast(AppLabels.Entry_for_the_contest, 3000);
                }else{
                    if(responseJson.data.game_type == 'dfs'){
                        WSManager.setPickedGameType(GameType.DFS);
                    }
                    if(responseJson.data.game_type == 'multigame'){
                        WSManager.setPickedGameType(GameType.MultiGame);
                    }
                    setTimeout(() => {
                        this.setState({
                            contestData: responseJson.data,
                            isReverseF: responseJson.data.is_reverse == 1 ? true : false
                        })
        
                        this.ContestDetailShow(responseJson.data, 2);
                        this.getUserLineUpListApi(responseJson.data)
                        
                    }, 200);
                }
            }
            this.setState({clickOnce: false})
        })
 }

    CreateTeamClickEvent = (data, LobyyData) => {
        if (!WSManager.loggedIn()) {
            setTimeout(() => {
                this.props.history.push({ pathname: '/signup' })
                Utilities.showToast(AppLabels.Please_Login_Signup_First, 3000);
            }, 10);
        } 
        else {
            WSManager.clearLineup();
            let urlData = LobyyData;
            let dateformaturl = Utilities.getUtcToLocal(urlData.season_scheduled_date);
            dateformaturl = new Date(dateformaturl);
            let dateformaturlDate = ("0" + dateformaturl.getDate()).slice(-2)
            let dateformaturlMonth = ("0" + (dateformaturl.getMonth() + 1)).slice(-2)
            dateformaturl = dateformaturlDate + '-' + dateformaturlMonth + '-' + dateformaturl.getFullYear();

            let lineupPath= '';
            if(urlData.home){
                let lineupPath = '/lineup/' + urlData.home + "-vs-" + urlData.away + "-" + dateformaturl
                this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { LobyyData: this.state.LobyyData, FixturedContest: this.state.contestData, resetIndex: 1, collection_master_id:urlData.collection_master_id,isReverseF: this.state.LobyyData.is_reverse || false } })
            }
            else{
                let pathurl = Utilities.replaceAll(urlData.collection_name,' ','_');
                lineupPath = '/lineup/' + pathurl + "-" + dateformaturl
                this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { LobyyData: this.state.LobyyData, FixturedContest: this.state.contestData ,resetIndex: 1,collection_master_id:urlData.collection_master_id,isReverseF: this.state.LobyyData.is_reverse || false} })
            }
        }
    }

    onSubmitBtnClick = (data) => {
        this.setState({LobyyData: data})
        if (!WSManager.loggedIn()) {
            setTimeout(() => {
                this.props.history.push({ pathname: '/signup' })
                Utilities.showToast(AppLabels.Please_Login_Signup_First, 3000);
            }, 10);
        } 
        else {
            if(this.state.userTeamListSend.length > 0){
                this.setState({showContestDetail:false,showConfirmationPopUp: true})
            }
            else{
                WSManager.clearLineup();
                let urlData = data;

                let dateformaturl = Utilities.getUtcToLocal(urlData.season_scheduled_date);
                dateformaturl = new Date(dateformaturl);
                let dateformaturlDate = ("0" + dateformaturl.getDate()).slice(-2)
                let dateformaturlMonth = ("0" + (dateformaturl.getMonth() + 1)).slice(-2)
                dateformaturl = dateformaturlDate + '-' + dateformaturlMonth + '-' + dateformaturl.getFullYear();

                let lineupPath= '';
                if(urlData.home){
                    lineupPath = '/lineup/' + urlData.home + "-vs-" + urlData.away + "-" + dateformaturl
                    this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { LobyyData: data, FixturedContest: this.state.contestData ,resetIndex: 1,collection_master_id:urlData.collection_master_id,isReverseF: data.is_reverse || false} })
                }
                else{
                    let pathurl = Utilities.replaceAll(urlData.collection_name,' ','_');
                    lineupPath = '/lineup/' + pathurl + "-" + dateformaturl
                    this.props.history.push({ pathname: lineupPath.toLowerCase(), state: { LobyyData: data, FixturedContest: this.state.contestData ,resetIndex: 1,collection_master_id:urlData.collection_master_id, isReverseF: data.is_reverse || false} })
                }
            }
        }
    }

    ConfirmEvent = (dataFromConfirmPopUp) => {
        if (dataFromConfirmPopUp.lineUpMasterIdArray && dataFromConfirmPopUp.lineUpMasterIdArray.length > 0) {
            var currentEntryFee = 0;
            currentEntryFee = dataFromConfirmPopUp.entryFeeOfContest;

            if (
                (dataFromConfirmPopUp.FixturedContestItem.currency_type == 2 && (parseInt(currentEntryFee) <= parseInt(dataFromConfirmPopUp.balanceAccToMaxPercent))) || 
                (dataFromConfirmPopUp.FixturedContestItem.currency_type != 2 && (parseFloat(currentEntryFee) <= parseFloat(dataFromConfirmPopUp.balanceAccToMaxPercent)))
                ) 
            {  
                this.CallJoinGameApi(dataFromConfirmPopUp);
            } 
            else {
                if(dataFromConfirmPopUp.FixturedContestItem.currency_type == 2){
                    if(EnableBuyCoin){    
                        WSManager.setFromConfirmPopupAddFunds(true);
                        WSManager.setContestFromAddFundsAndJoin(dataFromConfirmPopUp)
                        WSManager.setPaymentCalledFrom("SelectCaptainList")
                     this.props.history.push({ pathname: '/buy-coins', contestDataForFunds: dataFromConfirmPopUp, fromConfirmPopupAddFunds: true , state: {isFrom : 'contestList'}});

                    }
                    else{
                        this.props.history.push({ pathname:'/earn-coins', state: {isFrom : 'lineup-flow'}})
                    }
                }
                else{
                    WSManager.setFromConfirmPopupAddFunds(true);
                    WSManager.setContestFromAddFundsAndJoin(dataFromConfirmPopUp)
                    WSManager.setPaymentCalledFrom("SelectCaptainList")
                    this.props.history.push({ pathname: '/add-funds', contestDataForFunds: dataFromConfirmPopUp, fromConfirmPopupAddFunds: true });        
                }
            }
        } else {
            Utilities.showToast(AppLabels.SELECT_NAME_FIRST, 1000);
        }
    }

    CallJoinGameApi(dataFromConfirmPopUp) {
        let param = {
            "contest_id": dataFromConfirmPopUp.FixturedContestItem.contest_id,
            "promo_code": dataFromConfirmPopUp.promoCode,
        }
        let resultLineup = dataFromConfirmPopUp.lineUpMasterIdArray.map(a => a.lineup_master_id);
        param['lineup_master_id'] = resultLineup
        this.setState({ isLoaderShow: true })
        let IsNetworkContest = dataFromConfirmPopUp.FixturedContestItem.is_network_contest == 1 ? true:false;
        let apiCall = IsNetworkContest ? joinContestNetworkfantasy : joinContestWithMultiTeam;
        apiCall(param).then((responseJson) => {
            //this.setState({ isLoaderShow: false })

            if (responseJson.response_code == WSC.successCode) {
                this.ConfirmatioPopUpHide();
                setTimeout(() => {
                    WSManager.clearLineup();
                    Utilities.showToast(AppLabels.JOIN_SUCCESS_MESSAGE)
                    this.redirectToLobby();
                    //this.ThankYouModalShow()
                },300);
                WSManager.clearLineup();

            } else {
                Utilities.showToast(responseJson.global_error != "" ? responseJson.global_error : responseJson.message, 2000);
            }
        })
    }

    redirectToLobby = () => {
        this.goToLobby()
    }

    ConfirmatioPopUpShow = (data) => {
        this.setState({
            showConfirmationPopUp: true,

        });
    }

    ConfirmatioPopUpHide = () => {
        this.setState({
            showConfirmationPopUp: false,
        });
    }

    ThankYouModalShow = (data) => {
        this.setState({
            showThankYouModal: true,
        });
    }

    ThankYouModalHide = () => {
        this.setState({
            showThankYouModal: false,
        });
    }

    goToLobby = () => {
        this.props.history.push({ pathname: '/' });
    }

    seeMyContest = () => {
        this.props.history.push({ pathname: '/my-contests', state: { from: 'SelectCaptain' } });
    }

    getUserLineUpListApi = async (CollectionData) => {
        let param = {
            "sports_id": CollectionData.sports_id,
            "collection_master_id": CollectionData.collection_master_id,
        }
        this.setState({ isLoaderShow: true })
        let user_data = ls.get('profile');
        var user_unique_id = 0;
        if (user_data && user_data.user_unique_id) {
            user_unique_id = user_data.user_unique_id;
        }
        var api_response_data = await getUserTeams(param,user_unique_id);
        if (api_response_data) {
            this.setState({
                TotalTeam: api_response_data,
                userTeamListSend: (this.state.allowRevFantasy && SELECTED_GAMET == GameType.DFS) ? api_response_data.filter((obj,idx) => {
                    return (this.state.isReverseF ? obj.is_reverse == "1": obj.is_reverse != "1");
                }) : api_response_data
            })
            if (this.state.userTeamListSend) {
                let tempList = [];
                this.state.userTeamListSend.map((data, key) => {
                    tempList.push({ value: data, label: data.team_name })
                    return '';
                })

                this.setState({ userTeamListSend: tempList });
            }
        }

        
    }

    render() {
        const {
            mLeagueCode,
            showContestDetail,
            activeTab,
            contestData,
            clickOnce,
            showConfirmationPopUp,
            userTeamListSend,
            LobyyData,
            showThankYouModal,
            TotalTeam
        } = this.state;

        const HeaderOption = {
            back: true,
            backForLeagueCode : true,
        }
        return (

            <MyContext.Consumer>
                {(context) => (

                    <div className="web-container bg-white have-league-wrapper web-container-fixed">
                        <Helmet titleTemplate={`${MetaData.template} | %s`}>
                            <title>{MetaData.referral.title}</title>
                            <meta name="description" content={MetaData.referral.description} />
                            <meta name="keywords" content={MetaData.referral.keywords}></meta>
                        </Helmet>
                        <CustomHeader ref={this.headerRef} {...this.props} HeaderOption={HeaderOption} />
                        <div>{AppLabels.JOIN_CONTEST}</div>
                        <div className="webcontainer-inner ">
                            <div className="verification-block">
                                    <Row>
                                        <Col>
                                            <div className="onboarding-page-heading-lg">
                                                {AppLabels.HAVE_A_LEAGUE_CODE}
                                            </div>
                                            <div className="onboarding-page-desc">
                                                {AppLabels.EMAIL_USE}
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className="vertical-center-section">
                                        <Col xs={12} className="vertical-center-element">
                                            <FormGroup
                                                className='input-label-center input-transparent'
                                                controlId="formBasicText"
                                            >
                                                <FloatingLabel
                                                autoComplete='off'
                                                    styles={inputStyle}
                                                    id='league-code'
                                                    name='league-code'
                                                    placeholder={AppLabels.ENTER_LEAGUE_CODE}
                                                    type='text'
                                                    onChange={this.handleChange.bind(this)}
                                                    value={mLeagueCode}
                                                />

                                            </FormGroup>
                                        </Col>
                                    </Row>
                            </div>


                    </div>
                    <div className="space-section"></div>
                    <div className="league-btn-section">
                        <Button disabled={(mLeagueCode.length > 3 ? false : true) || clickOnce } onClick={() => this.joinPrivateLeague()} className="btn-block btm-fix-btn btn-primary">{AppLabels.JOIN_CONTEST}</Button>
                    </div>

                        {showContestDetail &&
                            <ContestDetailModal showPCError={true} IsContestDetailShow={showContestDetail} onJoinBtnClick={this.onSubmitBtnClick} IsContestDetailHide={this.ContestDetailHide} OpenContestDetailFor={contestData} activeTabIndex={activeTab} LobyyData={contestData} />
                        }

                        {showConfirmationPopUp &&
                             <ConfirmationPopup IsConfirmationPopupShow={this.ConfirmatioPopUpShow} IsConfirmationPopupHide={this.ConfirmatioPopUpHide} TeamListData={userTeamListSend} TotalTeam={TotalTeam} FixturedContest={contestData} ConfirmationClickEvent={this.ConfirmEvent} CreateTeamClickEvent={this.CreateTeamClickEvent} lobbyDataToPopup={LobyyData} fromContestListingScreen={true} createdLineUp={''} />
                        }

                        {showThankYouModal &&
                            <Thankyou ThankyouModalShow={this.ThankYouModalShow} ThankYouModalHide={this.ThankYouModalHide} goToLobbyClickEvent={this.goToLobby} seeMyContestEvent={this.seeMyContest} />
                        }
                    </div>
                )}
            </MyContext.Consumer>
        );
    }
}